import * as React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DettaglioCertificazione from './dettaglio-certificazione';
import DettaglioClienteCedacri from './dettaglio-cliente';
import RicercaAnagrafe from './ricerca-anagrafe';
import RicercaClienti from './ricerca-clienti';


const Ricerca: React.FC = () => {

  const { path } = useRouteMatch();

  return (

    <Switch>
      <Route path={`${path}`} component={RicercaClienti} exact />
      <Route path={`${path}/ricerca-anagrafe-cedacri`} component={RicercaAnagrafe} exact />
      <Route path={`${path}/:ndg`} component={DettaglioClienteCedacri} exact />
      <Route path={`${path}/:ndg/:id`} component={DettaglioCertificazione} exact />
    </Switch>

  )
}

export default Ricerca;
